import React from 'react';
import styled from 'styled-components/macro';

const Image = styled.img<PlaceProps>`
  z-index: ${(props) => (props.elevation ? props.elevation : 2)};
  height: ${(props) => props.height};
  position: absolute;
  top: ${(props) => props.top};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
  left: ${(props) => props.left};
`;

interface PlaceProps {
  elevation?: string;
  height?: string;
  top?: string;
  bottom?: string;
  right?: string;
  left?: string;
}

interface IProps {
  image: string;
  placeProps: PlaceProps;
}

/** 背景圖片調整位置元件 */
const PlaceImg: React.FC<IProps> = ({ image, placeProps }) => {
  return <Image {...placeProps} src={image} alt=""/>;
};

export default PlaceImg;
